module.exports = __webpack_public_path__ + "img/button.fec1425a.png";